module.exports = __webpack_public_path__ + "img/projects.8befc2bb.svg";